import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';

import s from './PriorityBadge.module.scss';

import type { FC } from 'react';

interface IPriorityBadgeProps {
  priority: string;
}

const PRIORITY_CONFIG: Record<string, { className: string; labelKey: string }> =
  {
    high: {
      className: s.high,
      labelKey: 'tasksDashboard.priority.high',
    },
    medium: {
      className: s.medium,
      labelKey: 'tasksDashboard.priority.medium',
    },
    low: {
      className: s.low,
      labelKey: 'tasksDashboard.priority.low',
    },
  };

const PriorityBadge: FC<IPriorityBadgeProps> = ({ priority }) => {
  const { t } = useTranslation();
  const config = PRIORITY_CONFIG[priority];

  if (!config) return <span>{priority}</span>;

  return (
    <Tag className={config.className} data-cy={`priority-badge-${priority}`}>
      {t(config.labelKey)}
    </Tag>
  );
};

export default PriorityBadge;
